import { theme } from 'Assets/Styles/theme'

const styles = {
  wrapper: {
    marginBottom: '24px',
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '10px',
    backgroundColor: '#F9F9FF',
    marginBottom: '16px',
  },

  headerTitle: {
    fontSize: '18px',
    fontFamily: "'Proxima Nova', sans-serif",
    color: '#011533',
    fontWeight: '700',
    marginRight: '18px',
  },

  text: {
    fontSize: '14px',
    fontWeight: '400',
    fontFamily: "'Proxima Nova', sans-serif",
    color: '#011533',
    marginTop: '12px',
    marginBottom: '12px',
  },

  nmbrsModalButton: {
    fontSize: '14px',
    fontWeight: '400',
    fontFamily: "'Proxima Nova' sans-serif",
    color: '#011533',
    marginTop: '12px',
    marginBottom: '12px',
    cursor: 'pointer',
    '&:hover': {
      color: 'blue',
    },
  },

  notProvidedText: {
    fontSize: '14px',
    fontWeight: '400',
    fontFamily: "'Proxima Nova' sans-serif",
    color: 'red',
  },

  btnWrapper: {
    display: 'flex',

    '& > div:first-child': {
      marginRight: '16px',
    },
  },
  buttonLabel: {
    fontSize: 16,
    color: theme.colors.primary,
  },
  active: {
    '& > p': {
      color: theme.colors.primary,
    },
  },
  disabled: {
    '& > p': {
      color: '#737373',
    },
  },

  noValue: {
    '& > p': {
      color: '#B6B6B6',
    },
  },

  table: {
    textAlign: 'center',
    borderRadius: '4px',

    '&  p': {
      fontSize: '14px',
    },
  },

  tableContainer: {
    maxHeight: '600px',
  },

  tableHead: {
    background: 'white',
  },
  tableRow: {
    marginBottom: 12,
    '& > div:first-child': {
      marginBottom: '0px',
    },
    '& td': {
      marginBottom: '0px !important',
      borderBottom: '1px solid #E2E2FC',
    },
  },

  tableHeaderCell: {
    width: '100px',
    background: 'white',
    border: 'none',
    fontFamily: "'Proxima Nova', sans-serif",
    fontSize: '14px',
    color: 'red',
  },

  firstTableHeaderCell: {
    width: '200px',
    background: 'white',
    border: 'none',
    fontFamily: "'Proxima Nova', sans-serif",
    fontSize: '14px',
    fontWeight: '400',
    color: 'red',
  },

  tableValue: {
    width: '100px',
  },

  outlinedInput: {
    padding: '4px',
    textAlign: 'left',
    width: '200px',
    fontFamily: "'Proxima Nova', sans-serif'",
    fontSize: '14px',
    color: '#011533',
  },

  editInput: {
    padding: '4px',
    textAlign: 'left',
    width: '400px',
    backgroundColor: '#E2E2FC',
  },

  tableHeadersLabel: {
    background: 'white',
    border: 'none',
    fontFamily: "'Proxima Nova', sans-serif",
    fontSize: '14px',
    color: '#707087',
  },

  outlinedNumberInput: {
    padding: '4px',
    textAlign: 'left',

    '& fieldset': {
      border: 'none',
    },
  },

  outlinedInputRoot: {
    width: '200px',
    padding: '4px',
    border: 'none',

    '& fieldset': {
      border: 'none',
    },
  },

  select: {
    height: 30,
    padding: 10,
    borderRadius: 4,
    backgroundColor: '#f8f8f8',
    paddingRight: 20,
    border: 'none',
    '& .MuiSelect-root': {
      backgroundColor: '#f8f8f8',
      width: 200,
      border: 'none',
      paddingLeft: 10,
    },
    '& svg': {
      marginRight: 10,
    },
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 10,
  },
  rowContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& td': {
      marginBottom: 0,
    },
  },
  comment: {
    minWidth: '160px',
  },

  activeDoc: {
    backgroundColor: '#E0F2E1',
  },
}

export default styles
